class GiftCardRecipient extends HTMLElement {
  connectedCallback() {
    const properties = Array.from(this.querySelectorAll('[name*="properties"]')),
      checkboxPropertyName = 'properties[__shopify_send_gift_card_to_recipient]';
    this.recipientCheckbox = properties.find((input) => input.name === checkboxPropertyName);
    this.recipientOtherProperties = properties.filter((input) => input.name !== checkboxPropertyName);
    this.recipientFieldsContainer = this.querySelector('.gift-card-recipient__fields');
    this.form = this.closest('form');
    this.formButton = this.form.querySelector('.ProductForm__AddToCart');
    this.emailField = this.querySelector('[type="email"]');

    this.recipientCheckbox?.addEventListener('change', this._synchronizeProperties.bind(this));

    this.formButton?.addEventListener('click', this._validateFormOpen.bind(this));

    this.offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');

    if (this.offsetProperty) {
      this.offsetProperty.value = new Date().getTimezoneOffset().toString();
    }

    this.recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]');
    const minDate = new Date();
    const maxDate = new Date();
    maxDate.setDate(minDate.getDate() + 90);
    this.recipientSendOnProperty?.setAttribute('min', this._formatDate(minDate));
    this.recipientSendOnProperty?.setAttribute('max', this._formatDate(maxDate));
  }

  _synchronizeProperties() {
    const isFormVisible = this.recipientCheckbox.checked;

    this.recipientOtherProperties.forEach((property) => (property.disabled = !isFormVisible));
    this.recipientFieldsContainer.classList.toggle('hidden', !isFormVisible);
    this._resetValidationStates();
  }

  _validateFormOpen(event) {
    const isFormVisible = this.recipientCheckbox.checked;

    if (isFormVisible && !this._validateForm()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  _formatDate(date) {
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - offset * 60 * 1e3);
    return offsetDate.toISOString().split('T')[0];
  }

  _validateForm() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const errorElement = this.emailField.closest('div').querySelector('.field-error');

    if (!emailRegex.test(this.emailField.value.trim())) {
      errorElement.classList.add('error');
      return false;
    }
    errorElement.classList.remove('error');
    return true;
  }

  _resetValidationStates() {
    const errorElement = this.emailField.closest('div').querySelector('.field-error');
    errorElement.classList.remove('error');
    this.emailField.value = '';
  }
}

if (!window.customElements.get('gift-card-recipient')) {
  window.customElements.define('gift-card-recipient', GiftCardRecipient);
}
